import type { ApiAuthGlobalType } from '../../../apps/api-hono/src/routes/api_auth_global/_router'
import { hc } from 'hono/client'
import { getClientRequestOptions } from './getClientRequestOptions';
import { getEnvVariable } from '@lib/utils/getEnvVariable';

const client = hc<ApiAuthGlobalType>('')
type Client = typeof client

export const createAuthGlobalApiClient = (...args: Parameters<typeof hc>): Client => {
    return hc<ApiAuthGlobalType>(...args)
}

export const authGlobalApiClient = createAuthGlobalApiClient(
    `https://${getEnvVariable('PUBLIC_API_DOMAIN')}/auth_global/`,
    getClientRequestOptions()
)
